/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";

export const SwitchWrap = styled.div`
  display: inline-block;
`;
